import React, { useState, useEffect, useContext } from 'react';
import { Cell } from 'react-foundation';
import { navigate } from '@reach/router';
import SimpleModal from './SimpleModal';
import { SimpleModalContent } from './SimpleModalContent';
import UserContext, { Roles } from '../../UserContext';

const UserPrefModal: React.FC = () => {
    const { user, hasAnyRole, hasSeenCommPrefModal, markCommPrefModalAsSeen } = useContext(UserContext);
    const [openModal, setOpenModal] = useState(false);

    // Show modal for providers who haven't seen it
    useEffect(() => {
        if (hasAnyRole(Roles.Provider) && hasSeenCommPrefModal === false) {
            setOpenModal(true);
        }
    }, [hasSeenCommPrefModal, user, hasAnyRole]);

    // Close handler
    const handleCloseCommPrefModal = () => {
        setOpenModal(false);
        markCommPrefModalAsSeen();
    };

    return (
        <SimpleModal open={openModal} onClose={handleCloseCommPrefModal} showCloseIcon={false} closeOnOverlayClick={false} closeOnEsc={false}>
            <SimpleModalContent
                mainTitle='Updated'
                subTitle='User Preferences'
                identifier={0}
                message={
                    <div>
                        <div>You can now customize your User Preferences with the following options:</div>
                        <ul>
                            <li><b>Text and Email Notifications:</b> Choose your preferred method of communication</li>
                            <li><b>Service Types:</b> Select the types of services you want to receive notifications for</li>
                            <li><b>Job Locations:</b> Specify the areas you want to cover for job opportunities</li>
                            <li><b>Additional Contacts:</b> Allow others to receive notifications on your behalf</li>
                        </ul>
                        <div><b>Take a moment to update your preferences now to ensure you receive the job notifications that matter most to you</b></div>
                    </div>
                }
            />
            <Cell className='simple-modal-button-section'>
                <button className='button alert action-simple-modal' onClick={() => {
                    handleCloseCommPrefModal();
                    navigate('/preferences');
                }}>
                    Continue
                </button>
            </Cell>
        </SimpleModal>
    );
};

export default UserPrefModal;